import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/* global localStorage */
import BaseStorage from '../base-storage';
import localStorageCleaner from '../utils/local-storage-cleaner';
import { verifyConsentPolicy } from '../consent-policy';
import { STORAGE_PREFIX, PREFIX_SEPARATOR, KEY_SEPARATOR, NOT_FOUND, LOCAL_STORAGE_UNSUPPORTED } from '../utils/constants';
import { getCacheRecords, deserializeData, isExpired } from '../utils/record-utils';

function getCacheKey(key, options) {
  return getCachePrefix(options) + key;
}

function stringify(obj) {
  return typeof obj === 'string' ? obj : JSON.stringify(obj);
}

function getCachePrefix(options) {
  return [STORAGE_PREFIX, options.namespace, stringify(options.scope)].filter(function (x) {
    return x;
  }).join(PREFIX_SEPARATOR) + KEY_SEPARATOR;
}

function serializeData(value, options) {
  return JSON.stringify({
    lastUsed: Date.now(),
    createdAt: options.createdAt || Date.now(),
    expiration: options.expiration,
    value: value
  });
}

function updateAccessTime(fullKey, data) {
  var expiration = data.expiration,
      createdAt = data.createdAt;
  localStorage.setItem(fullKey, serializeData(data.value, {
    expiration: expiration,
    createdAt: createdAt
  }));
}

var LocalStorageStrategy = /*#__PURE__*/function (_BaseStorage) {
  _inheritsLoose(LocalStorageStrategy, _BaseStorage);

  function LocalStorageStrategy() {
    return _BaseStorage.apply(this, arguments) || this;
  }

  var _proto = LocalStorageStrategy.prototype;

  _proto.setItem = /*#__PURE__*/function () {
    var _setItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, value, options) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              key = getCacheKey(key, options);
              value = serializeData(value, options); // not mandatory, yet (gradual enforcement)

              if (options.category) {
                verifyConsentPolicy(options.category);
              }

              try {
                localStorage.setItem(key, value);
              } catch (e) {
                localStorageCleaner(key.length + value.length);
                localStorage.setItem(key, value);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function setItem(_x, _x2, _x3) {
      return _setItem.apply(this, arguments);
    }

    return setItem;
  }();

  _proto.getItem = function getItem(key, options) {
    var fullKey = getCacheKey(key, options);
    var data;

    try {
      data = localStorage.getItem(fullKey);
    } catch (e) {
      return Promise.reject(LOCAL_STORAGE_UNSUPPORTED);
    }

    data = data && deserializeData(data);

    if (data && !isExpired(data)) {
      updateAccessTime(fullKey, data);
      return Promise.resolve(data.value);
    } else {
      return Promise.reject(NOT_FOUND);
    }
  };

  _proto.removeItem = function removeItem(key, options) {
    key = getCacheKey(key, options);
    localStorage.removeItem(key);
    return Promise.resolve();
  };

  _proto.getAllItems = function getAllItems(options) {
    var prefix = getCachePrefix(options);
    var items = {};
    getCacheRecords(prefix).forEach(function (record) {
      if (!isExpired(record)) {
        items[record.key] = record.value;
      }
    });
    return Promise.resolve(items);
  };

  return LocalStorageStrategy;
}(BaseStorage);

export { LocalStorageStrategy as default };